<template>
  <div id="base_nav" :class="[this.lang === 'ar' ? 'regular-ar' : 'regular-en' ,'w-100 h-100 justify-content-between']">
    <div :class="[this.lang === 'ar' ? 'flex-row-reverse' : '', 'cont nav-cont border-bottom-white-1-50 d-flex justify-content-between']">
<!--      <div v-if="$store.state.window >= 1100" :class="[this.lang === 'ar' ? 'flex-row-reverse' : '' ,'items flex-start-center']">-->
      <div :class="[this.lang === 'ar' ? 'flex-row-reverse' : '' ,'items flex-start-center']">
        <div class="item nav-item h-100 d-flex flex-center" v-for="(item, i) in mainInfo" :key="i" :class="active === i && lang === 'ar' ? 'active-item bold-ar' : active === i ? 'active-item bold-en' : ''">
          <router-link :to="item.path">
            <a>{{lang === 'ar' ? item.text.ar : item.text.en}}</a>
          </router-link>
        </div>
      </div>
<!--      <div class="position-relative" id="select_ar" v-if="this.lang === 'ar'">-->
<!--        <template v-if="$store.state.window < 1100">-->
<!--          <vue-simple-select @change="changeLocation"-->
<!--                             v-model="selected"-->
<!--                             :options="options"-->
<!--          />-->
<!--        </template>-->
<!--        <div class="active-absolute"></div>-->
<!--      </div>-->
<!--      <div class="position-relative" id="select_en" v-else>-->
<!--        <template v-if="$store.state.window < 1100">-->
<!--          <vue-simple-select @change="changeLocation"-->
<!--                             v-model="selected"-->
<!--                             :options="options"-->
<!--          />-->
<!--        </template>-->
<!--        <div class="active-absolute"></div>-->
<!--      </div>-->
      <div :class="[this.lang === 'ar' ? 'flex-start-center bold-ar' : 'flex-end-center bold-en', 'h-100 nav-service']"><img src="../../assets/icons/services.svg"><router-link :to="servicesUrl"><a :href="web + servicesUrl">{{$store.state.window >= 1100 ? serviceText : this.lang === 'ar' ? 'مراكز الخدمة' : 'Find CSC'}}</a></router-link></div>
    </div>
  </div>
</template>

<script>

// import store from '../../store'
// import { mapActions } from 'vuex'
import gc from '../../utils/gc'
import utils from '../../shared/utils'
// import VueSimpleSelect from 'vue-simple-custom-select'
import SocialLinksRepository from '../../repositories/SocialLinksRepository'
import $ from 'jquery'
export default {
  name: 'BaseNav',
  // components: { VueSimpleSelect },
  props: {
    data: {
      type: Array
    },
    active: {
      type: Number
    }
  },
  data () {
    return {
      mainInfo: [],
      type: 0,
      web: gc.website,
      servicesUrl: '/Support/Services-Centers',
      changeLang: utils.changeLang,
      lang: '',
      serviceText: this.$t('navbar.serviceCenter'),
      // paths: [],
      selected: {},
      options: [],
      socialRepo: new SocialLinksRepository()
    }
  },
  watch: {
  },
  created () {
    // console.log('full-path', this.$route.fullPath)
    // console.log('route', this.$route)
    if (localStorage.getItem('lang') !== '') {
      this.lang = localStorage.getItem('lang')
    }
    this.mainInfo = this.data
    this.type = this.active
    for (let i = 0; i < this.mainInfo.length; i++) {
      this.options.push({ label: this.lang === 'ar' ? this.mainInfo[i].text.ar : this.mainInfo[i].text.en, value: this.mainInfo[i].path })
    }
    const temp = []
    for (let i = 0; i < this.options.length; i++) {
      if (i !== this.$store.state.activeNav) {
        temp.push(this.options[i])
      }
      this.selected = this.options[this.$store.state.activeNav]
    }
    this.options = []
    this.options = [...temp]
    this.getData()
  },
  methods: {
    changeLocation () {
      this.$router.push(this.selected.value)
    },
    async getData () {
      try {
        const response = await this.socialRepo.get()
        if (response.status === 200) {
          this.$store.state.links = []
          for (let i = 0; i < response.data.length; i++) {
            this.$store.state.links.push({ type: response.data[i].type, link: response.data[i].link })
          }
        }
      } catch (e) {
        console.log(e)
      }
    }
  },
  mounted () {
    this.$watch(() => {
      return this.$store.state.window
    }, (val) => {
      if (val < 1100) {
        this.lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') : $('.vue-simple-select-container .vue-simple-select-button').css('flex-direction', 'row')
      }
    })
    setTimeout(() => {
      this.lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-button').addClass('flex-row-reverse') : $('.vue-simple-select-container .vue-simple-select-button').css('flex-direction', 'row')
      this.lang === 'ar' ? $('#base_nav .items').css('float', 'right') && $('#base_nav .items').css('flex-direction', 'row-reverse') : $('#base_nav .items').css('float', 'left') && $('#base_nav .items').css('flex-direction', 'row')
      this.lang === 'ar' ? $('.vue-simple-select-option').css('font-family', 'Mtn-arabic-regular') : $('.vue-simple-select-option').css('font-family', 'Mtn-regular')
      this.lang === 'ar' ? $('.vue-simple-select-container .vue-simple-select-dropdown').addClass('ar') : $('.vue-simple-select-container .vue-simple-select-dropdown').addClass('en')
    })
  }
}
</script>

<style  lang="scss">
@import "src/assets/sass/main";
.border-bottom-white-1-50 {
  border-bottom: 2px solid rgba(255, 255, 255, 0.5)!important;
}
.active-absolute {
  position: absolute;
  width: 100%;
  height: 2px;
  background: #FFCB05;
  bottom: -2px;
  z-index: 99;
}
#base_nav {
  height: 40px !important;
}
.boldArabic{
  font-family: Mtn-arabic-bold;
}
.nav-cont {
  height: 100%;
  margin: 0 2vw;
  padding: 0 2vw;
}
.nav-service {
  font-family: Mtn-bold;
  color: $--black; font-size: 13px;
}
.nav-service img {
  margin: 0.3rem;
  width: 17px; height: 21px;
}
.nav-item {
  min-width: 80px!important;
}
.select-page{
  height: 40px;
  border-bottom: 1px solid #FFCB05;
  color: #FFCB05;
  text-align: center;
}
</style>
<style lang="scss">
#base_nav {
.vue-simple-select-container .vue-simple-select-dropdown{
  z-index: 100;
  width: 100px!important;
  top: 100% !important;
  padding: 0;
  font-size: 10px
}
#select_ar .vue-simple-select-container .vue-simple-select-dropdown {
  left: 50%!important;
  transform: translateX(-50%);
}
#select_en .vue-simple-select-container .vue-simple-select-dropdown {
  left: 50%!important;
  transform: translateX(-50%);
}
.vue-simple-select-container .vue-simple-select-option.selected{
  background: rgb(242,242,242) !important;
  color: #383838 !important;
}
}
</style>
